import { VideoPlayer } from '@components';
import { GradientBackgroundVideoPlaySource } from '@constants/videos';
import { PerksbarContactEmail } from '@constants/perksbar';
import { SEOLayout } from '@layouts';
import Link from 'next/link';
import ScheduleForm from './components/ScheduleForm/ScheduleForm';
import styles from './styles.module.scss';

const ScheduleDemo = () => (
  <SEOLayout
    title="Schedule a Demo"
    description="Connect with a PerksBar expert to discuss the best solution for your organisation."
  >
    <div className={styles.container}>
      <VideoPlayer className={styles.videoBackground} {...GradientBackgroundVideoPlaySource} />

      <div className={styles.contentContainer}>
        <div className={styles.descriptionContainer}>
          <h1 className={styles.title}>Speak with an expert.</h1>
          <p className={styles.content}>
            Connect with a PerksBar expert to discuss the best solution for your organisation.
          </p>
          <p className={styles.content}>
            If you are looking for general information or support, please contact us{' '}
            <Link href={`mailto:${PerksbarContactEmail}`}>here</Link>.
          </p>
        </div>
        <div className={styles.formOuterContainer}>
          <ScheduleForm />
        </div>
      </div>
    </div>
  </SEOLayout>
);

export default ScheduleDemo;
